module.exports = __webpack_public_path__ + "static/media/09-luciola-cabral.935c7904.webp";